/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ projectName: NonNullable<unknown> }} Spaces_Badge_Via_ProjectInputs */



/**
* | output |
* | --- |
* | "via {projectName}" |
*
* @param {Spaces_Badge_Via_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_badge_via_project = /** @type {((inputs: Spaces_Badge_Via_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Badge_Via_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`via ${i?.projectName}`)
	return /** @type {LocalizedString} */ (`via ${i?.projectName}`)
});